export default {"src":"/_next/static/media/yt-logo.70f52a7a.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};